// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import LazyLoadImage from '../images/LazyLoadImage';

const ImageLogoBox = ({ src, alt, IconComponent, iconSx, imgWidth, imgHeight, sx, ...props }) => (
  <Box
    sx={{
      backgroundColor: 'white',
      borderRadius: 2,
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
      padding: 1,
      marginRight: { xs: 0, md: 1 },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: { xs: 50, md: 76 },
      minHeight: { xs: 34, md: 50 },
      ...sx,
    }}
    {...props}
  >
    {src ? (
      <LazyLoadImage src={src} alt={alt} width={imgWidth} height={imgHeight} />
    ) : (
      IconComponent && <IconComponent sx={iconSx || { fontSize: { xs: 22, md: 36 }, color: 'gray.A500' }} />
    )}
  </Box>
);

ImageLogoBox.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  IconComponent: PropTypes.elementType,
  iconSx: PropTypes.shape({}),
  imgWidth: PropTypes.number,
  imgHeight: PropTypes.number,
  sx: PropTypes.shape({}),
};

ImageLogoBox.defaultProps = {
  src: null,
  alt: '',
  IconComponent: null,
  iconSx: null,
  imgWidth: 60,
  imgHeight: 24,
  sx: {},
};

export default ImageLogoBox;
